import { Panel, Text } from "@ui5/webcomponents-react";
import { spacing } from "@ui5/webcomponents-react-base";
import { useEffect, useState } from 'react'
import axios from 'axios';
import Box from '@mui/material/Box';
import dayjs from 'dayjs';
import Button from '@mui/material/Button';
import {Link} from 'react-router-dom';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { Global } from '@emotion/react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useTheme } from '../utils/ThemeContext';
//import Skeleton from '@mui/material/Skeleton';

const Home = () => {
  const { theme } = useTheme();
  const [scoreCardAvailable, setScoreCardAvailable] = useState("none");
  const [datePlayed, setDatePlayed] = useState("");
  const [open, setOpen] = useState(false);
  const [buttonState, setButtonState] = useState(true);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
    setButtonState(!newOpen)
  };

  const drawerBleeding = 56;

  const Puller = styled('div')(() => ({
    width: 30,
    height: 6,
    ...(theme.drawerBg ? { backgroundColor: theme.drawerBg } : {}),
    borderRadius: 3,
    position: 'absolute',
    top: 8,
    left: 'calc(50% - 15px)',
  }));

  const StyledBox = styled('div')(() => ({
    ...(theme.drawerBg ? { backgroundColor: theme.drawerBg, color: theme.bodyText } : {}),
  }));

  const Root = styled('div')(() => ({
    height: '100%',
    ...(theme.muiOverride ? { backgroundColor: theme.bodyBg, color: theme.bodyText } : {}),
  }));

  //check if the scoring app is available for the week
  useEffect(() => {
    getData()
  }, [])

  async function getData() {
    await axios.get("api/courses/readWeeklyCourse.php")
    .then((response) => {
      if(response.data.records[0].weekCourseAvailable === "1"){
        setDatePlayed(response.data.records[0].courseDate)
        setScoreCardAvailable("block")
      }
    }).catch((error) =>{
      console.error("Error fetching data: ", error)
    }).finally(() => {
    })
  }

  let intro = (
  <Root>
      <Global
        styles={{
          '.MuiDrawer-root > .MuiPaper-root': {
            height: `calc(90% - ${drawerBleeding}px)`,
            overflow: 'visible',
          },
        }}
      />
    <Box display={scoreCardAvailable}>
      <Panel fixed stickyHeader style={{backgroundColor: theme.panelBg}} headerText={"Submit Score for " + dayjs(datePlayed).format('MMMM D, YYYY')}>
        <div align="center">
          <Button variant="contained" sx={{ backgroundColor: theme.primary, '&:hover': { backgroundColor: theme.primaryHover } }}>
            <Link to="/score" style={{textDecoration: "none", color: "white"}}>
              Submit Score
            </Link>
          </Button>
        </div>
      </Panel>
    </Box>
    <Panel fixed stickyHeader style={{backgroundColor: theme.panelBg}} headerText={"Who are we?"}>
      <Text style={spacing.sapUiContentPadding}>
        <p>The Waterloo Tech Golf League (WTGL) plays every Monday with tee times from 2:00pm to 6:00pm and running from May to September at Conestoga Golf and Country Club.</p>
        <p>We welcome golfers of all skill levels to join. In addition to having a great time, members also use the league as a networking opportunity.</p>
        <p>Each week members earn season points based on their score for that week relative to their handicap.  In addition there are multiple weekly cash skins, a weekly net winner, and two closest to the pin winners.</p>
        <p>At the end of the season in late September, a banquet and final tournament is held where awards, prizes and cash earnings are handed out</p>
      </Text>
    </Panel>
    <Panel fixed stickyHeader style={{backgroundColor: theme.panelBg}} headerText={"Fees"}>
      <Text style={spacing.sapUiContentPadding}>
        <p>League registration - $75<br />Weekly League Fee - $10<br/>
        All of the funds are put towards prizes at the end of the season.  Everyone receives a prize!</p>
      </Text>
    </Panel>
    <Panel fixed stickyHeader style={{backgroundColor: theme.panelBg}} headerText={"Contact Us"}>
      <Text style={spacing.sapUiContentPadding}>
        <p><span>If you are interested in joining the league, please contact us via email:</span></p>
        <address>
            <span><br /><a href="mailto:info@wtgl.ca?Subject=WTGL%20Information%20Request" target="_top">info@wtgl.ca</a><br /></span><br />
        </address>
      </Text>
      
    </Panel>
    <SwipeableDrawer
        id="swipeable-drawer"
        anchor="bottom"
        open={open}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        swipeAreaWidth={drawerBleeding}
        disableSwipeToOpen={false}
        ModalProps={{
          keepMounted: true,
        }}
      > 
        <StyledBox id="styledBox1"
          sx={{
            position: 'absolute',
            top: -drawerBleeding,
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            visibility: 'visible',
            right: 0,
            left: 0,
          }}
        >
          <Puller id="puller" />
          <div align="center">
          <Typography sx={{p: 2, color: theme.bodyText }}><Button sx={{pointerEvents: "all", textTransform: "none", color: theme.primary}} onClick={toggleDrawer(buttonState)}>Schedule</Button></Typography>
          </div>
        </StyledBox>
          <StyledBox
          sx={{
            px: 2,
            pb: 2,
            height: '100%',
            overflow: 'auto',
          }}
        >
        <div align="center">
          <Panel style={{fontSize: '14px'}}>
            <table>
              <tbody>
                <tr><td width="110">Monday April 27</td><td>Conestoga (Scramble)</td></tr>
              </tbody>
            </table>
          </Panel>
          <Panel style={{fontSize: '14px'}}>
            <table>
              <tbody>
                <tr><td width="110">Monday May 4</td><td>Conestoga</td></tr>
                <tr><td>Monday May 11</td><td>Conestoga</td></tr>
                <tr><td>Monday May 18</td><td>Conestoga</td></tr>
                <tr><td>Monday May 25</td><td>Conestoga</td></tr>
              </tbody>
            </table>
          </Panel>
          <Panel style={{fontSize: '14px'}}>
            <table>
              <tbody>
                <tr><td width="110">Monday June 1</td><td>Conestoga</td></tr>
                <tr><td>Monday June 8</td><td>Conestoga</td></tr>
                <tr><td>Monday June 15</td><td>Conestoga</td></tr>
                <tr><td>Monday June 22</td><td>Conestoga</td></tr>
                <tr><td>Monday June 29</td><td>Conestoga</td></tr>
              </tbody>
            </table>
          </Panel>
          <Panel style={{fontSize: '14px'}}>
            <table>
              <tbody>
                <tr><td width="110">Monday July 6</td><td>Conestoga</td></tr>
                <tr><td>Monday July 13</td><td>Conestoga</td></tr>
                <tr><td>Monday July 20</td><td>Conestoga</td></tr>
                <tr><td>Monday July 27</td><td>Conestoga</td></tr>
              </tbody>
            </table>
          </Panel>
          <Panel style={{fontSize: '14px'}}>
            <table>
              <tbody>
              <tr><td width="130">Monday August 3</td><td>Conestoga</td></tr>
              <tr><td>Monday August 10</td><td>Conestoga</td></tr>
              <tr><td>Monday August 17</td><td>Conestoga</td></tr>
              <tr><td>Monday August 24</td><td>Conestoga</td></tr>
              <tr><td>Monday August 31</td><td>Conestoga</td></tr>
              </tbody>
            </table>
          </Panel>
          <Panel style={{fontSize: '14px'}}>
            <table>
              <tbody>
                <tr><td width="160">Monday September 7</td><td>Conestoga</td></tr>
                <tr><td>Monday September 14</td><td>Conestoga</td></tr>
                <tr><td>Monday September 21</td><td>Conestoga</td></tr>
                <tr><td>Sunday September 27</td><td>Finals</td></tr>
              </tbody>
            </table>
          </Panel>
        </div>
        </StyledBox>
      </SwipeableDrawer>
  </Root>);

  return intro;
  };
  
  export default Home;
